import React from 'react';
import Send from '@mui/icons-material/Send';
import { useNotify, useRecordContext, useDataProvider } from 'react-admin';
import Button from '@mui/material/Button';
import { useMediaQuery } from '@mui/material';
import { useMutation } from 'react-query';

export const SendReportEmailButton = () => {
    const dataProvider = useDataProvider();
    const record = useRecordContext();
    const notify = useNotify();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const { mutate, isLoading } = useMutation(
        ['sendEmail'],
        () => dataProvider.sendEmail(`send_email/report`, {
            data: {
                "client_id": record.client_id,
                "report_url": record.report_url,
            }
        }),
        { onSuccess: () => notify('ra.notification.send_email', { type: 'success' }) },
        {
            onFailure: (error) => notify(`Erro no envio: ${error.message}`, { type: 'error' }),
        }
    );


    return (
        <>
            {isSmall ? (
                <Button
                    label="Enviar relatório"
                    children="Relatório"
                    onClick={() => mutate()}
                    disabled={isLoading}
                    variant="outlined"
                    color="primary"
                    icon={<Send />}
                />
            ) : (
                <Button
                    label="Enviar relatório"
                    children="Enviar relatório"
                    onClick={() => mutate()}
                    disabled={isLoading}
                    variant="outlined"
                    color="primary"
                    icon={<Send />}
                />
            )}
        </>
    )
}